'use strict';

import { regularWhite } from 'app/ui-components/design-tokens';
import { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import classNames from 'classnames';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import { trackCustomEvent } from '../../../../utils/statistics/clientStatistics';
import { mainMenuItemClickEvent } from '../../../../utils/statistics/customEvents';
import { Link as StyledMenuLink, ListItem } from './MenuItem.styles';

export const MenuItem = ({ route, accessKey, type, text, index, currentPath }) => {
    const classes = classNames(
        { 'play_is-active': route === currentPath }, // For integration tests
        `lp_pos${index + 1}`
    );

    return (
        <ListItem type={type} data-rt="menu-item">
            <Link href={route} passHref>
                <StyledMenuLink
                    size={SIZE.SMALL}
                    color={regularWhite}
                    isActive={route === currentPath}
                    className={classes}
                    accessKey={accessKey}
                    onClick={() => {
                        trackCustomEvent(mainMenuItemClickEvent(text, index));
                    }}
                >
                    {text}
                </StyledMenuLink>
            </Link>
        </ListItem>
    );
};

MenuItem.propTypes = {
    route: PropTypes.string.isRequired,
    accessKey: PropTypes.string.isRequired,
    type: PropTypes.string,
    text: PropTypes.string.isRequired,
    isIndexLink: PropTypes.bool,
    index: PropTypes.number,
};

export default MenuItem;
